export const MAX_CHAT_ATTACHMENTS = 4
export const MAX_CHAT_STANDARD_FILE_SIZE = 10 * 1024 * 1024
// Mantiene margine sotto il limite HTTP Convex di 20 MB (header inclusi).
export const MAX_CHAT_VIDEO_FILE_SIZE = 19 * 1024 * 1024
export const MAX_CHAT_TOTAL_SIZE = 40 * 1024 * 1024
export const MAX_CHAT_FILENAME_LENGTH = 180
export const CHAT_ATTACHMENT_ACCEPT =
  '.jpg,.jpeg,.png,.webp,.pdf,.mp4,.webm,.mov,image/jpeg,image/png,image/webp,application/pdf,video/mp4,video/webm,video/quicktime'

export const CHAT_ATTACHMENT_FORMATS_LABEL = 'JPEG, PNG, WebP, PDF, MP4, WebM o MOV'

const FILE_EXTENSIONS_BY_CONTENT_TYPE: Record<string, ReadonlySet<string>> = {
  'image/jpeg': new Set(['jpg', 'jpeg']),
  'image/png': new Set(['png']),
  'image/webp': new Set(['webp']),
  'application/pdf': new Set(['pdf']),
  'video/mp4': new Set(['mp4']),
  'video/webm': new Set(['webm']),
  'video/quicktime': new Set(['mov']),
}

const CONTENT_TYPE_BY_EXTENSION: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  pdf: 'application/pdf',
  mp4: 'video/mp4',
  webm: 'video/webm',
  mov: 'video/quicktime',
}

function fileExtension(filename: string) {
  return filename.trim().split('.').pop()?.toLowerCase() ?? ''
}

export function chatContentTypeForFile(file: File) {
  const declaredType = file.type.split(';', 1)[0].trim().toLowerCase()
  const inferredType = CONTENT_TYPE_BY_EXTENSION[fileExtension(file.name)]
  if (!declaredType || declaredType === 'application/octet-stream') {
    return inferredType ?? 'application/octet-stream'
  }
  return declaredType
}

export function isAllowedChatFile(file: File) {
  const contentType = chatContentTypeForFile(file)
  return FILE_EXTENSIONS_BY_CONTENT_TYPE[contentType]?.has(fileExtension(file.name)) ?? false
}

export function isChatVideoFile(file: File) {
  return isAllowedChatFile(file) && chatContentTypeForFile(file).startsWith('video/')
}

export function maxChatFileSize(file: File) {
  return isChatVideoFile(file) ? MAX_CHAT_VIDEO_FILE_SIZE : MAX_CHAT_STANDARD_FILE_SIZE
}

export function validateSingleChatFile(file: File): string | null {
  const filename = file.name.trim()
  if (
    !filename ||
    filename.length > MAX_CHAT_FILENAME_LENGTH ||
    /[\\/\u0000-\u001f\u007f]/.test(filename)
  ) {
    return 'Il file ha un nome troppo lungo o non valido.'
  }
  if (!isAllowedChatFile(file)) {
    return `Formato non supportato. Usa ${CHAT_ATTACHMENT_FORMATS_LABEL}.`
  }
  if (file.size <= 0) return 'Il file è vuoto e non può essere allegato.'
  const maxSize = maxChatFileSize(file)
  if (file.size > maxSize) {
    return isChatVideoFile(file)
      ? 'Il video supera il limite di 19 MB.'
      : 'Il file supera il limite di 10 MB.'
  }
  return null
}
